@if (!isLoading) {
  <div class="main-container" data-cy="perio-tooth-summary-main-container">
    <div class="header" data-cy="perio-tooth-summary-header">Tooth Summary</div>
    <i class="material-icons exit-button" (click)="close()" data-cy="perio-tooth-summary-close-button">close</i>
    @for (summarySection of summarySections; track summarySection; let i = $index) {
      <div class="summary-section"
        [class.padding-left]="summarySection.paddingLeft"
        [class.border-right]="summarySection.borderRight"
        [class.inline-summary]="summarySection.small"
        [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section'">
        <div class="section-header" [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section-header'">{{ summarySection.name }}</div>
        <div class="section-table" [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section-table'">
          <div class="table-headers" [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-table-headers'">
            @for (header of summarySection.headers; track header; let j = $index) {
              <div class="table-header"
                [class.no-right-border]="j === summarySection.headers.length-1"
                [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-header-' + header.name + '-label'">
                {{ header.name }}
              </div>
            }
          </div>
          @for (section of summarySection.sections; track section) {
            <div class="table-secion" [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section-' + section.name + '-row'">
              <div class="section-value" [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section-' + section.name + '-label'">
                {{ section.name }}
              </div>
              @for (sectionValue of section.values; track sectionValue; let j = $index) {
                <div class="section-value"
                  [class.no-right-border]="j === section.values.length-1"
                  [attr.data-cy]="'perio-tooth-summary-' + summarySection.name + '-section-' + section.name + '-value-' + j">
                  {{ sectionValue }}
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}
@if (isLoading) {
  <div class="spinner-container" data-cy="perio-tooth-summary-loading-spinner">
    <mat-spinner></mat-spinner>
  </div>
}
